<script>
  import Select from "svelte-select";
  import { createEventDispatcher } from "svelte";
  import { _ } from "svelte-i18n";
  import { locales } from "../../scripts/l10n.js";

  export let defaultVal;

  let selectedLocale = {value: defaultVal, label: locales[defaultVal]};

  //Parse Object structure for svelte-select to work
  let parsedLocales = [];
  for (let [key, value] of Object.entries(locales)) {
    parsedLocales.push({value: key, label: value})
  }

  const dispatch = createEventDispatcher();
  function handleLangChange(event) {
    //console.log("selected:", event.detail.value);
    //event.preventDefault();
    dispatch("lang-changed", event.detail.value)
  }
</script>

<div class="lang-selector">
  <Select items={parsedLocales} value={selectedLocale} isClearable={false} on:select={handleLangChange}/>
</div>

<style>
  .lang-selector {
    padding: 10px;
    background: white;
    --borderFocusColor: #f1b6e8;
    --itemHoverBG: #ffeafc;
    --itemIsActiveBG: #f1b6e8;
  }
</style>